export default __webpack_public_path__ + "static/media/Headshot-3.52834f40.png";